export const environment = {
    production: false,
    authApiUrl: 'https://clw-stg-api-report.phoenixph.com/auth',
    cignalApiUrl: 'https://clw-stg-api-report.phoenixph.com'
};
